import type { UseInViewOptions } from "motion/react";

export const defaultPreviewLazyLoadConfig: UseInViewOptions = { once: true, margin: "300px" };
